// School-local calendar dates as "YYYY-MM-DD" strings. Never built from the browser clock (REVIEW 1.8):
// "today" always comes from GET /school.

/** Parses "YYYY-MM-DD" to a UTC-midnight Date used only for arithmetic and formatting. */
export function parseIsoDate(isoDate: string): Date {
  const parts: string[] = isoDate.split("-");
  const year: number = Number(parts[0]);
  const month: number = Number(parts[1]);
  const day: number = Number(parts[2]);
  return new Date(Date.UTC(year, month - 1, day));
}

/** Formats a UTC-midnight Date back to "YYYY-MM-DD". */
export function toIsoDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/** The date plus a number of days. */
export function addDays(isoDate: string, days: number): string {
  const date: Date = parseIsoDate(isoDate);
  date.setUTCDate(date.getUTCDate() + days);
  return toIsoDate(date);
}

/** Monday of the week containing the date (weeks start on Monday, SPEC §2). */
export function mondayOf(isoDate: string): string {
  const date: Date = parseIsoDate(isoDate);
  const daysSinceMonday: number = (date.getUTCDay() + 6) % 7;
  return addDays(isoDate, -daysSinceMonday);
}

/** 0 = Monday … 6 = Sunday. */
export function weekdayIndex(isoDate: string): number {
  return (parseIsoDate(isoDate).getUTCDay() + 6) % 7;
}

/** Whole days from the first date to the second. */
export function daysBetween(fromIsoDate: string, toIsoDate: string): number {
  const millisecondsPerDay: number = 24 * 60 * 60 * 1000;
  return Math.round((parseIsoDate(toIsoDate).getTime() - parseIsoDate(fromIsoDate).getTime()) / millisecondsPerDay);
}
